import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isAppLoading: true,
    sidebarOpenedItem: null,
    isSidebarOpen: false,
    subscriptionModal: null,
};

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setIsAppLoading: (state, action) => {
            state.isAppLoading = action.payload;
        },
        setSidebarItem: (state, action) => {
            state.sidebarOpenedItem = action.payload;
        },
        setIsSidebarOpen: (state, action) => {
            state.isSidebarOpen = action.payload;
        },
        clearSidebarItem: (state) => {
            state.sidebarOpenedItem = null;
        },
        setSubscriptionModal: (state, action) => {
            state.subscriptionModal = action.payload;
        },
    },
});

export default appSlice.reducer;
export const {
    setIsAppLoading,
    setSidebarItem,
    clearSidebarItem,
    setIsSidebarOpen,
    setSubscriptionModal,
} = appSlice.actions;
